import { colors, sizes, themeColors } from "@hubrise/react-components"
import styled, { css } from "styled-components"

import { DefaultStyle } from "Catalog/Edit/shared/components/Navigator"
import { ItemRenderProps } from "Catalog/Edit/shared/components/Navigator/types"

import { constants } from "../Styles"

export const Name = styled.div<{ isEnabled?: boolean }>`
  ${DefaultStyle.nameCss};

  > span {
    color: ${colors.textLight};
    font-weight: 400;

    &:after {
      content: ">";
      margin: 0 0.5em;
    }
  }

  ${({ isEnabled }) => isEnabled === false && "text-decoration: line-through;"};
`

export const StyledProduct = styled.div<ItemRenderProps>`
  ${DefaultStyle.itemCss};
`

export const StyledCategory = styled.div<ItemRenderProps>`
  ${DefaultStyle.itemCss};

  margin-top: ${constants.categoryGap};
  border-radius: ${sizes.borderRadius} ${sizes.borderRadius} 0 0;
  color: ${colors.textDark};
  font-weight: 500;
  background-color: ${colors.backgroundLightest};

  ${({ isSelected }) =>
    isSelected &&
    css`
      ${Name} > span {
        color: white;
      }
      &:hover {
        background-color: ${themeColors.primary};
      }
    `};

  & + & {
    margin-top: 0;
    border-radius: 0;
  }
`
